import { DataTablePagination, PanelInfo } from '@/components/custom';
import DataTableHeader from './DataTableHeader';
import Loader from '@/components/custom/Loader';
import DataTableBody from './DataTableBody';
import { useEmployees } from '../../hooks';
import { Table } from '@/components/ui';
import { Podcast } from 'lucide-react';

export const DataTable = () => {

  const { isLoading, data, employees } = useEmployees();

  if (isLoading) {
    return (
      <div className='my-10'>
        <Loader className='my-10' />
      </div>
    );
  }

  if (employees.length === 0) {
    return (
      <PanelInfo
        title='Aucun utilisateur trouvé'
        description={`Vous n'avez pas d'utilisateurs respectant ces critères. Ajoutez-en un ci-dessus.`}
        className='py-10 md:py-26 border-none'
        icon={Podcast} />
    );
  }

  return (
    <div className='space-y-5'>
      <div className='border rounded-md'>
        <Table>
          <DataTableHeader />
          <DataTableBody />
        </Table>
      </div>
      <DataTablePagination pageCount={data.pagination.pageCount} />
    </div>
  );

};

export default DataTable;
